export function nextStage(stage) {
  let next = stage;
  if (stage === "discovery") next = "value1";
  if (stage === "value1") next = "working";
  if (stage === "working") next = "value2";
  if (stage === "value2") next = "accepted";
  return next;
}
